import warning from "../Assets/warning_colored.svg";
import critical from "../Assets/critical_colored.svg";
import notice from "../Assets/notice.png";
import error from "../Assets/error_colored.svg";

export const getNotificationdataMetadata = (item) => {
  let itemMeta = {
    label: "Warning",
    icon: warning,
  };
  switch (item.severity) {
    case "critical": {
      itemMeta = {
        label: "Critical",
        icon: critical,
      };
      break;
    }
    case "error": {
      itemMeta = {
        label: "Error",
        icon: error,
      };
      break;
    }
    case "notice": {
      itemMeta = {
        label: "Notice",
        icon: notice,
      };
      break;
    }
    default: {
      itemMeta = {
        ...itemMeta,
        label: "Warning",
        icon: warning,
      };
      break;
    }
  }

  return itemMeta;
};
